import { K5QueryUtils as K5Query } from './kibana5-query-utils';
import { K6QueryUtils as K6Query } from './kibana6-query-utils';
export const KibanaQueryUtils = {
    K5Query,
    K6Query,
};
//# sourceMappingURL=index.js.map